"use client";

import type { AppRouter } from "@/types/trpc";
import { getGeneratedListTrpcEndpoint } from "@/utils/trpc/generated-list-route";
import type { HTTPLinkOptions } from "@trpc/client";

type GeneratedListFetch = NonNullable<
  HTTPLinkOptions<AppRouter["_def"]["_config"]["$types"]>["fetch"]
>;

const generatedListTransportPrefix = "/api/trpc-list/";

export function rewriteGeneratedListTrpcUrl(
  requestUrl: string,
  origin = globalThis.location?.origin ?? "http://localhost",
) {
  const url = new URL(requestUrl, origin);

  if (!url.pathname.startsWith(generatedListTransportPrefix)) {
    throw new Error(
      `Generated-list transport received an unexpected URL: ${JSON.stringify(url.pathname)}.`,
    );
  }

  const procedurePath = decodeURIComponent(
    url.pathname.slice(generatedListTransportPrefix.length),
  );
  const endpoint = getGeneratedListTrpcEndpoint(procedurePath);
  url.pathname = `${endpoint}/${procedurePath}`;

  return url.toString();
}

export const fetchGeneratedListTrpcRequest: GeneratedListFetch = (
  request,
  options,
) => {
  const requestUrl = typeof request === "string"
    ? request
    : request instanceof URL
    ? request.toString()
    : request.url;
  const rewrittenUrl = rewriteGeneratedListTrpcUrl(requestUrl);

  if (request instanceof Request) {
    return globalThis.fetch(new Request(rewrittenUrl, request), options);
  }

  return globalThis.fetch(rewrittenUrl, options);
};
